import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 100px 0;
    gap: 80px;
  }
`

export const Content = styled.div`
  padding: 0 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 0 100px;
  }
  
  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 0 200px;
  }
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.large}) {
    gap: 50px;
  }
`

export const Text = styled.div`
  color: ${({theme}) => theme.business.colors.textColor};
  font-size: 16px;
  line-height: 30px;
  font-weight: 400;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const CardBlock = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg width='1921' height='219' viewBox='0 0 1921 219' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.4'%3E%3Cpath d='M1921 151.563V82.6857C1921 82.6857 1744.5 9.11238 1394.5 0.659465C1044.5 -7.79345 612 67.6581 373 75.7981C134 83.938 0.5 0.659465 0.5 0.659465V179.427C0.5 179.427 98 224.773 307.5 217.309C517 209.845 703 116.882 1182.5 83.938C1662 50.9939 1921 151.563 1921 151.563Z' fill='white' fill-opacity='0.5'/%3E%3Cpath d='M1921 151.563V82.6857C1921 82.6857 1744.5 9.11238 1394.5 0.659465C1044.5 -7.79345 612 67.6581 373 75.7981C134 83.938 0.5 0.659465 0.5 0.659465V179.427C0.5 179.427 98 224.773 307.5 217.309C517 209.845 703 116.882 1182.5 83.938C1662 50.9939 1921 151.563 1921 151.563Z' fill='url(%23paint0_linear_1_14255)' fill-opacity='0.5'/%3E%3Cpath d='M0 90.7346V80.3176C0 80.3176 176.546 40.4946 526.637 33.4633C876.728 26.4321 1308.31 81.9418 1548.4 100.953C1788.5 119.964 1921 59.1151 1921 59.1151V112.125C1921 112.125 1841.98 141.497 1632.42 135.289C1422.87 129.08 1218.32 83.2632 738.692 55.8597C259.067 28.4562 0 90.7346 0 90.7346Z' fill='url(%23paint1_linear_1_14255)' fill-opacity='0.6'/%3E%3Cpath d='M0 90.7346V80.3176C0 80.3176 176.546 40.4946 526.637 33.4633C876.728 26.4321 1308.31 81.9418 1548.4 100.953C1788.5 119.964 1921 59.1151 1921 59.1151V112.125C1921 112.125 1841.98 141.497 1632.42 135.289C1422.87 129.08 1218.32 83.2632 738.692 55.8597C259.067 28.4562 0 90.7346 0 90.7346Z' fill='url(%23paint2_linear_1_14255)'/%3E%3Cpath opacity='0.4' d='M1921 126.516V113.993C1921 113.993 1744.5 40.42 1394.5 31.9671C1044.5 23.5142 612 98.9657 373 107.106C134 115.246 0.5 31.9671 0.5 31.9671V129.96C0.5 129.96 79.5 161.844 289 154.38C498.5 146.917 703 91.8359 1182.5 58.8917C1662 25.9476 1921 126.516 1921 126.516Z' fill='url(%23paint3_linear_1_14255)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_1_14255' x1='-2579.01' y1='-152.925' x2='-2580.31' y2='202.697' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0' stop-opacity='0.41'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_1_14255' x1='4501.18' y1='-60.8905' x2='4501.47' y2='107.542' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_1_14255' x1='1018.5' y1='-66.0097' x2='988.607' y2='121.864' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='%232F87A5'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_1_14255' x1='-2579.01' y1='-55.7653' x2='-2579.43' y2='146.722' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
`

export const ButtonBlock = styled.div`
  text-align: center;

  @media only screen and (${({theme}) => theme.media.large}) {
  }
`

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;

  @media only screen and (${({theme}) => theme.media.large}) {
    flex-direction: row;
    gap: 100px;
  }
`

export const Card = styled.div`
  padding: 20px;
  border-radius: 40px;
  border: 1px;
  background: ${({theme}) => theme.business.colors.cardBackground1};
  text-align: center;
`

export const CardImage = styled.img`
  width: 100%;
`

export const CardText = styled.div`
  padding: 13px 0 0 0;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 24px;
    line-height: 33px;
    font-weight: 600;
  }
`

export const back = styled.div`
  height: 300px;
  display: block;
  background-image: url("data:image/svg+xml,%3Csvg width='1921' height='219' viewBox='0 0 1921 219' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.4'%3E%3Cpath d='M1921 151.563V82.6857C1921 82.6857 1744.5 9.11238 1394.5 0.659465C1044.5 -7.79345 612 67.6581 373 75.7981C134 83.938 0.5 0.659465 0.5 0.659465V179.427C0.5 179.427 98 224.773 307.5 217.309C517 209.845 703 116.882 1182.5 83.938C1662 50.9939 1921 151.563 1921 151.563Z' fill='white' fill-opacity='0.5'/%3E%3Cpath d='M1921 151.563V82.6857C1921 82.6857 1744.5 9.11238 1394.5 0.659465C1044.5 -7.79345 612 67.6581 373 75.7981C134 83.938 0.5 0.659465 0.5 0.659465V179.427C0.5 179.427 98 224.773 307.5 217.309C517 209.845 703 116.882 1182.5 83.938C1662 50.9939 1921 151.563 1921 151.563Z' fill='url(%23paint0_linear_1_14255)' fill-opacity='0.5'/%3E%3Cpath d='M0 90.7346V80.3176C0 80.3176 176.546 40.4946 526.637 33.4633C876.728 26.4321 1308.31 81.9418 1548.4 100.953C1788.5 119.964 1921 59.1151 1921 59.1151V112.125C1921 112.125 1841.98 141.497 1632.42 135.289C1422.87 129.08 1218.32 83.2632 738.692 55.8597C259.067 28.4562 0 90.7346 0 90.7346Z' fill='url(%23paint1_linear_1_14255)' fill-opacity='0.6'/%3E%3Cpath d='M0 90.7346V80.3176C0 80.3176 176.546 40.4946 526.637 33.4633C876.728 26.4321 1308.31 81.9418 1548.4 100.953C1788.5 119.964 1921 59.1151 1921 59.1151V112.125C1921 112.125 1841.98 141.497 1632.42 135.289C1422.87 129.08 1218.32 83.2632 738.692 55.8597C259.067 28.4562 0 90.7346 0 90.7346Z' fill='url(%23paint2_linear_1_14255)'/%3E%3Cpath opacity='0.4' d='M1921 126.516V113.993C1921 113.993 1744.5 40.42 1394.5 31.9671C1044.5 23.5142 612 98.9657 373 107.106C134 115.246 0.5 31.9671 0.5 31.9671V129.96C0.5 129.96 79.5 161.844 289 154.38C498.5 146.917 703 91.8359 1182.5 58.8917C1662 25.9476 1921 126.516 1921 126.516Z' fill='url(%23paint3_linear_1_14255)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_1_14255' x1='-2579.01' y1='-152.925' x2='-2580.31' y2='202.697' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0' stop-opacity='0.41'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_1_14255' x1='4501.18' y1='-60.8905' x2='4501.47' y2='107.542' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_1_14255' x1='1018.5' y1='-66.0097' x2='988.607' y2='121.864' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='%232F87A5'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_1_14255' x1='-2579.01' y1='-55.7653' x2='-2579.43' y2='146.722' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%234FC0C0'/%3E%3Cstop offset='0.822917' stop-color='%2300637B'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center, 50%, 50%;
`